<div class="list-page" *ngIf="!loading && projectVm; else placeholder">
  <div class="project-overview-actions">
    <button
      type="button"
      class="back-button"
      (click)="goBack()"
      data-testid="project-overview-back"
    >
      <span class="material-icons">keyboard_arrow_left</span>Back to Dashboard
    </button>

    <!-- Open Workspace lives on the site card (same place as the Active list),
         so the vendor isn't looking in two spots. Project-level bulk actions
         (Submit All Quotes / Accept All Offers / Sign ATP) are rendered by the
         `app-project-group` banner below (CON-154), the same as every other
         list screen. -->
  </div>

  <app-project-group
    [project]="projectVm"
    [type]="'project-overview'"
    (atpSigned)="signedAtpSiteVisits = $event"
  ></app-project-group>
  <div *ngIf="!projectVm.sites.length" class="empty-state" data-testid="project-overview-all-declined">
    You've declined every product on this project.
  </div>
</div>

<ng-template #placeholder>
  <div class="list-page">
    <div
      *ngIf="loading; else notLoading"
      class="empty-state"
      data-testid="project-overview-loading"
    >
      <p class="empty-state__title">Loading project overview…</p>
    </div>
    <ng-template #notLoading>
      <button
        type="button"
        class="back-button"
        (click)="goBack()"
        data-testid="project-overview-back"
      >
        <span class="material-icons">keyboard_arrow_left</span>Back to Dashboard
      </button>
      <div class="empty-state" data-testid="project-overview-empty">
        <p class="empty-state__title">No project data available</p>
      </div>
    </ng-template>
  </div>
</ng-template>

<!-- Page-hosted CONFIRMATION dialogs (Spec 8, <app-modal>) — cover both this
     page's bulk actions and the per-product actions inline on app-product-line
     (a card refresh destroys the row that triggered them, so the confirmation
     has to live here instead). -->
<allbids-submitted-dialog
  [active]="bidSubmittedActive"
  (modalClosed)="toggleCloseSubmittedAllBidsModal()"
  [ngClass]="{ 'documents-dialog--active': bidSubmittedActive }"
/>
<bidsubmitted-dialog
  [active]="singleBidSubmittedActive"
  (modalClosed)="toggleCloseSubmittedBidModal()"
  [ngClass]="{ 'documents-dialog--active': singleBidSubmittedActive }"
/>
<!-- Single `atp-sign-accepted-dialog` instance (CON-154 Task 5): both the
     inline per-product ATP sign and the banner's bulk "Sign ATP for All
     Awarded Sites" relay through `(atpSigned)` → `isAtpSignAcceptedModalOpen`,
     so the second, `isSignedAtpModalOpen`-driven instance this page used to
     carry for its own bulk sign is redundant. -->
<atp-sign-accepted-dialog
  [active]="isAtpSignAccepted"
  [address]="address"
  [modalHeaderTitle]="childModalHeaderTitle"
  [modalBody]="childModalBody"
  [dashboard]="false"
  [siteVisits]="signedAtpSiteVisits"
  (modalClosed)="toggleCloseAtpSignAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isAtpSignAccepted }"
/>
<accepted-offered-proposal-dialog
  [active]="isOfferAcceptedActive"
  [multiple]="isOfferAcceptedMultiple"
  (modalClosed)="toggleCloseOfferAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isOfferAcceptedActive }"
/>
<decline-success
  [batch]="declineBatch"
  [active]="declineSuccessActive"
  [address]="address"
  [isFixedPrice]="isFixedPrice"
  [isAtp]="isAtp"
  (modalClosed)="toggleCloseDeclineSuccessModal()"
  [ngClass]="{ 'documents-dialog--active': declineSuccessActive }"
/>
<site-visit-confirmation-dialog
  [active]="siteVisitConfirmationActive"
  (modalClose)="toggleCloseSiteVisitConfirmationModal()"
/>
